import React, { useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getScheduleUpdatedBySelector } from '../../../redux/slices/ganttSlice.js';
import { Colors } from '../../../constants/colors.constants.js';
import { SaveIcon } from '../../../icons/index.js';
import MemberAvatar from '../../CollaborativeSpaceMembers/MemberAvatar/MemberAvatar.tsx';
import './GanttOutdatedBanner.scss';
import { type Member } from '../../../assets/js/collaborative_space/index.ts';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils.js';
import { trackingEvent } from '../../../analytics/index.js';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants.js';

interface GanttOutdatedBannerProps {
  scheduleUpdatedBy: {
    member: Member | null;
    updatedAt: Date | null;
  };
}

const GanttOutdatedBanner = ({
  scheduleUpdatedBy
}: GanttOutdatedBannerProps) => {
  const { t } = useTranslation();
  const { member, updatedAt } = scheduleUpdatedBy;

  useEffect(() => {
    if (member) {
      trackingEvent(
        'schedule_refresh_prompt',
        {
          ...getBasicAmplitudEventProperties()
        },
        AMPLITUDE_SERVICE
      );
    }
  }, [member]);

  if (!member) {
    return null;
  }

  return (
    <div className="gantt-outdated-banner">
      <SaveIcon color={Colors.RED} />
      <MemberAvatar member={member} />
      <div
        dangerouslySetInnerHTML={{
          __html: t('master_plan.schedule_has_changed', {
            name: member.profileData?.fullName,
            time: moment(updatedAt).calendar()
          })
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  scheduleUpdatedBy: getScheduleUpdatedBySelector(state)
});

export default connect(mapStateToProps)(GanttOutdatedBanner);
